import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringLegislationLinkHealth = api(async function getAuthoringLegislationLinkHealth({ id }) {
    return query(
        gql`
            query GetAuthoringLegislationLinkHealth($id: String!) {
                getAuthoringLegislationLinkHealth(id: $id) {
                    level
                    message
                }
            }
        `,
        { id },
        { returns: "getAuthoringLegislationLinkHealth", fetchPolicy: "network-only" }
    )
})
